import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Select } from 'primeng/select';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { Toast } from 'primeng/toast';
import { RestaurantFormComponent } from '../../_components/restaurant-form/restaurant-form.component';
import {LocationStrategy} from '@angular/common';
import {Constants} from '../../_utility';
import {Router} from '@angular/router';
import {BreadcrumbsService} from '../../_components/breadcrumbs/breadcrumbs.service';
import {ApiService, AuthService} from '../../_services';
import {Restaurant} from '../../_models/Restaurant';
import {MessageService} from 'primeng/api';
import {SpinnerService} from '../../_components/spinner/spinner.service';

@Component({
  selector: 'app-edit-restaurant',
  templateUrl: './edit-restaurant.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RestaurantFormComponent, Select, FormsModule, ReactiveFormsModule, TranslateModule, DynamicDialogModule],
})
export class EditRestaurantComponent implements OnInit {
  form: FormGroup;
  Restaurants: Array<Restaurant> = [];
  selectedRestaurant: Restaurant | undefined;
  ships: any[] = [];
  protected readonly Constants = Constants;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private location: LocationStrategy,
    public dialog: DialogService,
    public router: Router,
    private breadcrumb: BreadcrumbsService,
    private apiService: ApiService,
    private messageService: MessageService,
    private spinner: SpinnerService,
    private translate: TranslateService
  ) {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      globalIdIn: ['', [Validators.required]],
      globalIdOut: ['', [Validators.required]],
      picture: ['', [Validators.required]],
      myItalianPercentage: [
        '',
        [Validators.required, Validators.min(0), Validators.minLength(0)],
      ],
      ship: ['', [Validators.required]],
      table: this.fb.array([]),
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.MODIFICA_RISTORANTE.path);
    }, 200);
    const currentUser = this.auth.getCurrentUser();
    if (currentUser) {
      // Get user's ships from local storage
      const userDataStr = localStorage.getItem('currentUser');
      if (userDataStr) {
        const userData = JSON.parse(userDataStr);
        if (userData.ships && userData.ships.length > 0) {
          // Transform ships data to match the format needed by the dropdown
          this.ships = userData.ships.map((ship: any) => ({
            name: ship,
            code: ship,
          }));
        }
      }
    }
    this.spinner.show();
    this.apiService.Restaurants().subscribe({
      next: (data) => {
        this.Restaurants = data;
        this.spinner.hide();
      },
      error: (error) => {
        console.error(error);
        this.spinner.hide();
      },
    });
  }

  onRestaurantChange(event: any) {}

  showResult(event: boolean) {
    if (event) {
      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('messages.success_title'),
        detail: this.translate.instant('messages.restaurant_updated'),
        life: Constants.Notifications.LIFE,
        key: Constants.Notifications.SUCCESS_KEY,
      });
      this.selectedRestaurant = undefined;
    }
  }

  Back() {
    this.goTo('restaurant_management');
  }
  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'restaurant_management': {
        this.router.navigate(Constants.Routing.HOME_RISTORANTI.routerLink);
        break;
      }
    }
  }
}
